﻿import controller from '../../../../Resources/Scripts/_Shared/controller';
import { appendContent, openOverlay } from '../../_Shared/Scripts/MyAimoParkOverlay'

function landlordAdministratorsPage(context) {
  const htmlElement = document.querySelector('html');
  const overlayContext = context.querySelector("[data-controller=myaimopark-overlay]");

  function init() {
    context.addEventListener('click', async function (event) {
      if (event.target.dataset.addNew) {
        event.preventDefault();

        const heading = event.target.dataset.heading;

        //Open administrator overlay
        openOverlay(overlayContext, { heading, hideLoader: true });

        //const getSeasonTicketInformation = await seasonTickets.getSeasonTicketInformation({ id: event.target.dataset.seasonticketId }).catch((err) => err);

        //if (getSeasonTicketInformation.status === 200) {
        //  if(htmlElement.classList.contains('map-overlay-active')) {
        //    appendContent(overlayContext, null, getSeasonTicketInformation.body);
        //  }
        //} else {
        //  appendContent(overlayContext, { error: true });
        //}
      }
    });
  }

  return {
    init
  };
}

controller.add('landlord-administrators-page', landlordAdministratorsPage);